import React from 'react';
import propTypes from 'prop-types';

export const KeyIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g id="surface1">
        <path
          stroke="none"
          fillRule="nonzero"
          fill={color}
          fillOpacity={1}
          d="M 21.710938 2.289062 C 18.65625 -0.765625 13.695312 -0.765625 10.640625 2.289062 C 8.648438 4.289062 7.890625 7.144531 8.617188 9.851562 L 0.226562 18.304688 C 0.0820312 18.453125 0 18.652344 0 18.859375 L 0 23.21875 C 0 23.648438 0.351562 24 0.78125 24 L 5.140625 24 C 5.347656 24 5.546875 23.917969 5.695312 23.773438 L 6.800781 22.664062 C 6.945312 22.515625 7.035156 22.320312 7.035156 22.109375 L 7.035156 20.757812 L 8.460938 20.757812 C 8.667969 20.757812 8.867188 20.664062 9.015625 20.519531 L 10.121094 19.414062 C 10.265625 19.265625 10.375 19.066406 10.375 18.859375 L 10.375 17.476562 L 11.78125 17.476562 C 11.988281 17.476562 12.1875 17.34375 12.335938 17.199219 L 14.148438 15.382812 C 16.859375 16.109375 19.710938 15.351562 21.710938 13.359375 C 24.765625 10.304688 24.765625 5.34375 21.710938 2.289062 Z M 19.429688 9 C 18.210938 10.21875 16.226562 10.21875 15.003906 9 C 13.78125 7.777344 13.78125 5.792969 15.003906 4.570312 C 16.226562 3.351562 18.210938 3.351562 19.429688 4.570312 C 20.648438 5.792969 20.648438 7.777344 19.429688 9 Z M 19.429688 9 "
        />
      </g>
    </svg>
  );
};
KeyIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
KeyIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
